

import React from "react";
import { experiences } from "../constants";

/* ═══════════════════════════════════════════════════════════
   EXPERIENCE — Luxury Timeline
   Gold hairline · alternating cards · liquid reveals
   ═══════════════════════════════════════════════════════════ */

const ExperienceCard = ({ experience, index }) => {
  const isEven = index % 2 === 0;

  return (
    <div className="relative pl-16 md:pl-0">
      {/* Timeline node */}
      <div
        className="absolute left-0 md:left-1/2 md:-translate-x-1/2 top-2 w-3 h-3 rounded-full bg-champagne-500 shadow-[0_0_20px_rgba(212,175,55,0.5)]"
        aria-hidden="true"
      />

      <div
        className={`md:w-[calc(50%-3rem)] ${
          isEven ? "md:mr-auto" : "md:ml-auto"
        }`}
      >
        <div className="lux-card reveal-fade p-8">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-4">
              <img
                src={experience.icon}
                alt={experience.company_name}
                className="w-10 h-10 object-contain opacity-70"
                loading="lazy"
              />
              <div>
                <h3 className="font-grotesk text-base font-medium text-silver-100">
                  {experience.title}
                </h3>
                <p className="text-xs text-champagne-400 tracking-wide">
                  {experience.company_name}
                </p>
                {experience.location && (
                  <p className="text-[0.65rem] text-silver-500 mt-1 tracking-wide">
                    {experience.location}
                  </p>
                )}
              </div>
            </div>
            <span className="font-grotesk text-[0.65rem] tracking-[0.15em] uppercase text-silver-500 whitespace-nowrap">
              {experience.date}
            </span>
          </div>

          <ul className="space-y-3">
            {experience.points.map((point, i) => (
              <li
                key={`point-${i}`}
                className="lux-body text-sm flex gap-3"
              >
                <span className="text-champagne-500 mt-1" aria-hidden="true">
                  —
                </span>
                <span>{point}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

const Experience = () => {
  return (
    <div className="lux-container">
      <div className="max-w-3xl mb-20">
        <p className="lux-eyebrow mb-6">What I have done so far</p>
        <h2 className="lux-heading">
          <span className="reveal-line">
            <span>Work</span>
          </span>
          <span className="reveal-line">
            <span className="lux-gold">Experience</span>
          </span>
        </h2>
      </div>

      {/* Timeline */}
      <div className="relative">
        {/* Vertical hairline */}
        <div
          className="absolute left-[5px] md:left-1/2 md:-translate-x-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-champagne-500/40 via-champagne-500/10 to-transparent"
          aria-hidden="true"
        />

        <div className="space-y-16">
          {experiences.map((exp, i) => (
            <ExperienceCard key={`exp-${i}`} experience={exp} index={i} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Experience;